import { useEffect, useState } from "react";
import { DEFAULT_MARKETPLACE_RANGE, formatPercent } from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchSeoMarketplaceAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { AnalyticsSummaryGrid } from "../AdminAnalyticsShared";
import { MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminSeoAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchSeoMarketplaceAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <MarketplaceAnalyticsShell
      active="seo"
      title="Analytics SEO"
      description="Landing pages, guías, inventario indexable y conversión desde SEO."
      range={range}
      onRangeChange={setRange}
      viewEvent="seo_analytics_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && totals ? (
        <>
          <AnalyticsSummaryGrid
            items={[
              { label: "Vistas SEO", value: totals.seoPageViews },
              { label: "Sesiones SEO", value: totals.seoSessions },
              { label: "Leads SEO", value: totals.seoLeads },
              { label: "Conv. SEO", value: formatPercent(totals.seoLeadConversionRate) },
              { label: "Guías vistas", value: totals.guidePageViews },
              { label: "CTA guías", value: totals.guideCtaClicks },
              { label: "Checklist desde SEO", value: totals.checklistFromSeo },
              { label: "Indexables", value: totals.indexablePageCount },
              { label: "Noindex", value: totals.noindexPageCount },
              { label: "Sitemap", value: totals.sitemapPageCount },
            ]}
          />
          <section className="dealer-state-box">
            <h3>Páginas SEO</h3>
            {!payload.topPages?.length ? (
              <p className="muted">Sin páginas SEO registradas.</p>
            ) : (
              <table className="dealer-inventory-table">
                <thead>
                  <tr>
                    <th>Página</th>
                    <th>Tipo</th>
                    <th>Vistas</th>
                    <th>Inventario</th>
                    <th>Clics</th>
                    <th>Leads</th>
                    <th>Conv.</th>
                    <th>Index</th>
                  </tr>
                </thead>
                <tbody>
                  {payload.topPages.map((row) => (
                    <tr key={row.page}>
                      <td>{row.page}</td>
                      <td>{row.pageType}</td>
                      <td>{row.views}</td>
                      <td>{row.inventoryCount ?? "—"}</td>
                      <td>{row.listingClicks}</td>
                      <td>{row.leads}</td>
                      <td>{formatPercent(row.conversionRate)}</td>
                      <td>{row.indexStatus}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </section>
          {payload.noInventoryPages?.length ? (
            <section className="dealer-state-box">
              <h3>SEO sin inventario</h3>
              <ul>
                {payload.noInventoryPages.map((row) => (
                  <li key={row.page}>{row.page}</li>
                ))}
              </ul>
            </section>
          ) : null}
        </>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
